import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=4358eef8&scoped=true"
import script from "./_slug.vue?vue&type=script&lang=js"
export * from "./_slug.vue?vue&type=script&lang=js"
import style0 from "./_slug.vue?vue&type=style&index=0&id=4358eef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4358eef8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ExploreCard: require('/workspace/components/ExploreCard.vue').default})
